module.exports = __webpack_public_path__ + "img/inventory-mac.4f615a05.png";